import { Box, TextField } from '@material-ui/core'
import React from 'react'
import './track.css'

interface Props {
  name?: string
  link?: string
  setName: (name: string) => void
  setLink: (link: string) => void
  isDisabled: boolean
  title?: string
}

const EditFile: React.FC<Props> = ({ isDisabled, setName, setLink, name, link, title }) => {
  return (
    <>
      <form>
        <Box
          style={{
            color: '#fc6404'
          }}
        >
          {title || ''}
        </Box>
        <Box display="flex" flexDirection="column">
          <TextField
            label="Nombre"
            variant="outlined"
            margin="normal"
            value={name}
            disabled={isDisabled}
            onChange={e => setName(e.target.value)}
            required
          />
          <TextField
            label="Enlace"
            variant="outlined"
            margin="normal"
            value={link}
            disabled={isDisabled}
            onChange={e => setLink(e.target.value)}
            required
          />
        </Box>
      </form>
    </>
  )
}

export default EditFile
